import { studyGuideEntries, studyTypes } from "./study-skills"
export const groups = [
  "Use cases",
  "How-to guides",
  "Activity routines",
  "Study skills",
]
export const routineCategories = ["Music", "Sports", "Study"]

export const articles = [
  {
    title: "School Holiday Screen Time: A Routine for Every Age",
    description:
      "Make room for games, movement, friends and rest with a practical holiday routine for children aged 5–8, 9–12 and 13–17.",
    url: "/use-cases/school-holiday-screen-time/",
    image: "article-school-holiday-screen-time.png",
    group: "Use cases",
    category: "Use cases",
    activityType: "Family Planning",
  },
  {
    title: "Export to Apple Calendar or Google Calendar",
    description:
      "Download all saved events as an .ics file from the export dialog or AI Chat, then import them into Apple Calendar or Google Calendar.",
    url: "/how-to-guides/export-apple-google-calendar/",
    image: "article-export-apple-google-calendar.png",
    group: "How-to guides",
    category: "How-to guides",
    activityType: "Calendar export",
  },
  {
    title: "Lock Your Calendar to a Weekly View",
    description:
      "Keep a weekly timetable in view, hide dates and navigation, and share the routine with families.",
    url: "/how-to-guides/lock-calendar-weekly-view/",
    image: "article-lock-calendar-weekly-view.png",
    group: "How-to guides",
    category: "How-to guides",
    activityType: "Weekly view",
  },
  {
    title: "Generate Calendar Events with AI",
    description:
      "Describe your schedule, review the proposed events, and add them to your calendar with Magic Generate.",
    url: "/how-to-guides/generate-calendar-events-ai/",
    image: "article-generate-calendar-events-ai.png",
    group: "How-to guides",
    category: "How-to guides",
    activityType: "Generate events",
  },
  {
    title: "Publish and Share Your Calendar",
    description:
      "Publish a read-only calendar, add an optional password, and keep the same link when plans change.",
    url: "/how-to-guides/publish-share-calendar/",
    image: "article-publish-share-calendar.png",
    group: "How-to guides",
    category: "How-to guides",
    activityType: "Publish and share",
  },

  {
    title: "Create a Weekly Classroom Calendar and Share It with Parents",
    description:
      "Follow a Year 3 example: add lessons, try Magic Generate, publish a read-only calendar, and update the same link when plans change.",
    url: "/use-cases/weekly-classroom-calendar/",
    image: "article-weekly-classroom-calendar.png",
    group: "Use cases",
    category: "Use cases",
    activityType: "Classroom Planning",
  },
  {
    title: "Build an After-School Activity Schedule with AI",
    description:
      "Turn homework, sport, and music practice into a weekly calendar. Copy an example prompt, review the events, and share the plan.",
    url: "/use-cases/after-school-activity-schedule-ai/",
    image: "article-after-school-activity-schedule-ai.png",
    group: "Use cases",
    category: "Use cases",
    activityType: "Family Planning",
  },
  {
    title: "Create a Visual Homeschool Weekly Schedule",
    description:
      "Plan a homeschool week with subject icons, reusable activities, separate calendars, and events drafted in Magic Generate.",
    url: "/use-cases/visual-homeschool-weekly-schedule/",
    image: "article-visual-homeschool-weekly-schedule.png",
    group: "Use cases",
    category: "Use cases",
    activityType: "Homeschool Planning",
  },
  {
    title: "Create and Share a School Club Schedule",
    description:
      "Create a clear school club calendar with session details, a read-only link, optional password protection, and updates at the same URL.",
    url: "/use-cases/school-club-schedule/",
    image: "article-school-club-schedule.png",
    group: "Use cases",
    category: "Use cases",
    activityType: "Club Planning",
  },
  {
    title: "Move Your Calendar Events with One Chat Request",
    description:
      "Shift calendar events earlier or later with a chat request. Review the selected events, confirm the move, and republish your updated schedule.",
    url: "/how-to-guides/move-calendar-events-with-chat/",
    image: "article-move-calendar-events-with-chat.png",
    group: "How-to guides",
    category: "How-to guides",
    activityType: "Schedule Changes",
  },
  {
    title: "Violin practice routines for different AMEB levels",
    description:
      "A practical guide to structuring warm-ups, scales, pieces, sight reading, and aural work from early grades through advanced AMEB preparation.",
    url: "/activity-routines/music/violin-practice-routines-ameb-levels/",
    image: "blog-violin.png",
    group: "Activity routines",
    category: "Music",
    activityType: "Practice Routine",
  },
  {
    title: "Piano practice routines for different AMEB levels",
    description:
      "Plan piano practice around reading, technique, voicing, repertoire, sight reading, aural work, and performance confidence.",
    url: "/activity-routines/music/piano-practice-routines-ameb-levels/",
    image: "blog-piano.png",
    group: "Activity routines",
    category: "Music",
    activityType: "Practice Routine",
  },
  {
    title: "Guitar practice routines for different AMEB levels",
    description:
      "Build clean coordination, tone, rhythm, fretboard confidence, and reliable performance habits for AMEB guitar preparation.",
    url: "/activity-routines/music/guitar-practice-routines-ameb-levels/",
    image: "blog-guitar.png",
    group: "Activity routines",
    category: "Music",
    activityType: "Practice Routine",
  },
  {
    title: "Singing practice routines for different AMEB levels",
    description:
      "Healthy routines for warm-ups, breath, diction, sight singing, repertoire, aural work, and performance presence.",
    url: "/activity-routines/music/singing-practice-routines-ameb-levels/",
    image: "blog-singing.png",
    group: "Activity routines",
    category: "Music",
    activityType: "Practice Routine",
  },
  {
    title: "Flute practice routines for different AMEB levels",
    description:
      "A level-by-level guide to tone, breathing, articulation, scales, sight reading, and exam-ready flute practice.",
    url: "/activity-routines/music/flute-practice-routines-ameb-levels/",
    image: "blog-flute.png",
    group: "Activity routines",
    category: "Music",
    activityType: "Practice Routine",
  },
  {
    title: "Cello practice routines for different AMEB levels",
    description:
      "Practice ideas for relaxed setup, bow control, shifting, intonation, tone, repertoire, and performance flow.",
    url: "/activity-routines/music/cello-practice-routines-ameb-levels/",
    image: "blog-cello.png",
    group: "Activity routines",
    category: "Music",
    activityType: "Practice Routine",
  },
  {
    title: "Soccer training routines for different levels",
    description:
      "Plan ball control, passing, shooting, defending, match play, fitness, and recovery from beginner to advanced levels.",
    url: "/activity-routines/sports/soccer-training-routines/",
    image: "blog-soccer.png",
    group: "Activity routines",
    category: "Sports",
    activityType: "Training Routine",
  },
  {
    title: "Basketball training routines for different levels",
    description:
      "Build dribbling, shooting, footwork, defence, game-speed decisions, conditioning, and recovery across the week.",
    url: "/activity-routines/sports/basketball-training-routines/",
    image: "blog-basketball.png",
    group: "Activity routines",
    category: "Sports",
    activityType: "Training Routine",
  },
  {
    title: "Tennis training routines for different levels",
    description:
      "Structure tennis practice around strokes, serves, returns, footwork, match patterns, fitness, and recovery.",
    url: "/activity-routines/sports/tennis-training-routines/",
    image: "blog-tennis.png",
    group: "Activity routines",
    category: "Sports",
    activityType: "Training Routine",
  },
  {
    title: "Swimming training routines for different levels",
    description:
      "Organise pool sessions around breathing, body position, stroke technique, pacing, race skills, and recovery.",
    url: "/activity-routines/sports/swimming-training-routines/",
    image: "blog-swimming.png",
    group: "Activity routines",
    category: "Sports",
    activityType: "Training Routine",
  },
  {
    title: "Running training routines for different levels",
    description:
      "Plan easy runs, workouts, long runs, strength, mobility, race preparation, and recovery without overloading the week.",
    url: "/activity-routines/sports/running-training-routines/",
    image: "blog-running.png",
    group: "Activity routines",
    category: "Sports",
    activityType: "Training Routine",
  },
  {
    title: "Cricket training routines for different levels",
    description:
      "Balance batting, bowling, fielding, match scenarios, strength, speed, workload, and recovery in a weekly routine.",
    url: "/activity-routines/sports/cricket-training-routines/",
    image: "blog-cricket.png",
    group: "Activity routines",
    category: "Sports",
    activityType: "Training Routine",
  },
  {
    title: "English study routines for different school levels",
    description:
      "Build reading, vocabulary, paragraph writing, analysis, essay planning, timed responses, and feedback habits.",
    url: "/activity-routines/study/english-study-routines/",
    image: "blog-english.png",
    group: "Activity routines",
    category: "Study",
    activityType: "Study Routine",
  },
  {
    title: "Math study routines for different school levels",
    description:
      "Plan number facts, algebra, problem solving, topic revision, exam questions, and error review across the week.",
    url: "/activity-routines/study/math-study-routines/",
    image: "blog-math.png",
    group: "Activity routines",
    category: "Study",
    activityType: "Study Routine",
  },
  {
    title: "Science study routines for different school levels",
    description:
      "Study concepts, diagrams, experiments, data, active recall, and exam responses with a repeatable routine.",
    url: "/activity-routines/study/science-study-routines/",
    image: "blog-science.png",
    group: "Activity routines",
    category: "Study",
    activityType: "Study Routine",
  },
  {
    title: "History study routines for different school levels",
    description:
      "Organise timelines, key terms, source analysis, evidence, essay plans, and timed history responses.",
    url: "/activity-routines/study/history-study-routines/",
    image: "blog-history.png",
    group: "Activity routines",
    category: "Study",
    activityType: "Study Routine",
  },
  {
    title: "Geography study routines for different school levels",
    description:
      "Use maps, case studies, diagrams, data, fieldwork, and extended responses in a clear weekly study plan.",
    url: "/activity-routines/study/geography-study-routines/",
    image: "blog-geography.png",
    group: "Activity routines",
    category: "Study",
    activityType: "Study Routine",
  },
  ...studyGuideEntries,
]

export const categoriesForGroup = (group: string): string[] =>
  group === "Activity routines"
    ? routineCategories
    : group === "Study skills"
    ? studyTypes
    : []

export const parseGuideFilters = (query: string) => {
  const params = new URLSearchParams(query)
  const requestedGroup = params.get("group")
  const requestedCategory = params.get("category") || "All"
  const group =
    requestedGroup && groups.includes(requestedGroup)
      ? requestedGroup
      : !requestedGroup && routineCategories.includes(requestedCategory)
      ? "Activity routines"
      : "All"
  const category = categoriesForGroup(group).includes(requestedCategory)
    ? requestedCategory
    : "All"
  return { group, category }
}
